<template>
  <div v-if="$route.params.query" class="modal fade hmodal-info" id="modalTableResult" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="color-line" style="display: block;"></div>
        <div class="modal-header">
          <h4 class="modal-title text-capitalize"><span style="font-weight: bold;">{{ dataType === 'author' ? 'Science' : 'Patents' }} Data Table</span></h4>
        </div>
        <div class="modal-body">
          <table id="authorTable" class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .modal-xl {
    width: 70%;
    margin: auto;
  }
  #authorTable {
    width: 98% !important;
    margin: auto;
  }
</style>

<script>
import 'datatables.net-select-bs/css/select.bootstrap.min.css'
import 'datatables.net-select-bs/js/select.bootstrap.min'

export default {
  props: ['value', 'allAuthors', 'dataType'],
  name: 'ScienceDataTable',
  data () {
    return {
      dataTable: null,
      authors: []
    }
  },
  mounted () {
    $('#modalTableResult').modal()
    $('#modalTableResult').on('hidden.bs.modal', () => {
      this.$emit('input', false)
    })

    this.authors = this.allAuthors.filter(author => {
      return (author.topDocument && author.docs)
    }).map(author => ({
      firstName: author.firstName || 'n/a',
      lastName: author.lastName || 'n/a',
      affiliation: author.affiliation,
      topDocument: author.topDocument,
      docs: author.docs,
      score: author.score < 0.01 ? 0.01 : author.score
    }))

    const formattedData = []

    this.authors.forEach(author => {
      author.docs.forEach(doc => {
        const coauthorsList = doc.co_authors.map(coauthor => {
          return `<li>${coauthor.firstName} ${coauthor.lastName}</li>`
        }).join(' ')

        formattedData.push({
          firstName: author.firstName,
          lastName: author.lastName,
          organisationName: author.affiliation && author.affiliation.organisationName ? author.affiliation.organisationName : 'n/a',
          country: author.affiliation && author.affiliation.country ? author.affiliation.country : 'n/a',
          title: doc.title || 'n/a',
          publication: doc.publication || 'n/a',
          pubDate: doc.pubDate || 'n/a',
          abstract: doc.abstract || 'n/a',
          score: parseFloat(author.score.toFixed(2)),
          coAuthor: coauthorsList || 'n/a',
          link: doc.link || 'n/a'
        })
      })
    })

    this.dataTable = $('#authorTable').DataTable({
      pageLength: 10,
      responsive: true,
      processing: true,
      data: formattedData,
      columns: [
        { data: 'lastName', title: 'Last Name' },
        { data: 'firstName', title: 'First Name' },
        { data: 'organisationName', title: 'Company Name' },
        { data: 'country', title: 'Country' },
        { data: 'title', title: 'Title', render: function (data) { return data || 'n/a' } },
        { data: 'publication', title: 'Publication', render: function (data) { return data || 'n/a' } },
        { data: 'pubDate', title: 'Publication Date', render: function (data) { return data || 'n/a' } },
        { data: 'coAuthor', title: 'Co-Authors' },
        { data: 'score', title: 'Score' },
        { data: 'link', title: 'Document Link', render: data => data !== 'n/a' ? `<a href="${data}" target="_blank">link</a>` : 'n/a', orderable: false },
        { data: 'link', title: 'Link', visible: false },
        { data: 'abstract', title: 'Full Abstract', visible: false }
      ],
      dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>t<'row'<'col-sm-3'i><'col-sm-6 text-center'p><'col-sm-3'>>",
      buttons: [
        { extend: 'copy', className: 'btn btn-xs btn-info btn-outline' },
        {
          extend: 'csv',
          text: 'Export as CSV',
          className: 'btn btn-xs btn-info btn-outline',
          exportOptions: {
            columns: ':not(:eq(9))',
            modifier: {
              order: 'current',
              page: 'all'
            }
          }
        }
      ],
      columnDefs: [],
      rowId: 'authorID',
      initComplete: () => {
      }
    })
  },
  methods: {
  },
  beforeDestroy () {
    if (this.dataTable) {
      this.dataTable.destroy()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/ScienceDataTable.vue